import { type DomainAccessControlConfig } from '../utils/domain/accessControl'
import { type Permission } from './permissions'
import { type FeatureToggle } from './featureToggles'

// eslint-disable-next-line @retailer-platform/archlint/no-empty-access-control -- TODO: add proper access control (CXPRA-134)
export const ippNavIntrospectAdminAccessControl: DomainAccessControlConfig = {}
